/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 广告控制器
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from "../../helpers";
import { BaseModel, BasesController } from '../bases';
export class FeekbackController<T = any> extends BasesController<T> {
    constructor() {
        super({
            insert: EnumAPI.content_feekback_save
        })
    }
    Modal = new BaseModel({ type: 'object' })
    @computed
    get feekbackType() {
        return lodash.get(this.Modal.value, 'feekbackType', [])
    }
    /**
     * 获取 反馈类型
     */
    async getFeekbackType() {
        const feekbackType = await AjaxBasics.requestEnum(EnumAPI.content_feekback_type, { labelKey: 'name', valueKey: 'code' });
        // 不需要 SN 类型
        this.Modal.merge({ feekbackType: lodash.pullAllBy(feekbackType, [{ value: "serialnumber" }], 'value') })
    }
}